export default "<option value=\"{{value}}\">\n  <ng-content></ng-content>\n</option>"